
import Vue from 'vue';
import { mapGetters, mapActions, mapState } from 'vuex';

import Modal from '@/components/layout/modal.vue';
import { ProfileActions } from '@/store/modules/user/profile/types';
import { ClinicalTrainingEventsActions } from '@/store/modules/clinical-training-events/types';
import imageSizeMixin from '@/components/mixins/image-size';

export default imageSizeMixin.extend({
  name: 'ClinicalEventsModalLayout',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('user/profile', ['showClinicalEventsModal']),
    ...mapState('clinicalTrainingEvents', {
      events: 'list',
    }),
    ...mapGetters('clinicalTrainingEvents', {
      isLoading: 'listIsLoading',
      isLoaded: 'listIsLoaded',
    }),
  },
  methods: {
    ...mapActions('user/profile', {
      closeModal: ProfileActions.CLOSE_CLINICAL_EVENTS_MODAL,
    }),
    ...mapActions('clinicalTrainingEvents', {
      loadEvents: ClinicalTrainingEventsActions.LOAD_ACTIVE,
      subscribeToEvent: ClinicalTrainingEventsActions.SUBSCRIBE,
    }),
    close() {
      this.closeModal();
    },
    joinEvent(event: any) {
      this.subscribeToEvent({ id: event.id });
    },
    formatDate(dateString: string) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      }) + ' EST';
    },
  },
  watch: {
    showClinicalEventsModal(newVal) {
      if (newVal && !this.isLoaded) {
        // Only load events if they haven't been loaded yet
        this.loadEvents();
      }
    }
  },
});
